import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import axios from './axios';
import toast from './toast';
import VueLazyLoad from 'vue3-lazyload'

import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;

import 'slick-carousel/slick/slick.css';
import '../public/css/style.scss';

// Remove this if you're no longer using polyfills or IE support
import 'core-js/stable';

import 'maz-ui/css/main.css'
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';

// Create Vue app instance
const app = createApp(App);

// Global properties
app.config.globalProperties.$http = axios;
app.config.globalProperties.$toast=toast;

// Use plugins
app.use(router);
app.use(store);
app.use(i18n);
app.use(toast)
app.use(VueLazyLoad)
app.use(VueTelInput)

// Mount app
app.mount('#app');
